import { forEach, find } from 'lodash';

/* ---------------------------------------------------- */
/* NEW Get Best Class Name                                  */
/* ---------------------------------------------------- */
/*
	It tries to find most important class name among classes.
	If no class, use ID else use the tag name.
*/

export default function getTheBestClass( classes ) {

	/* ---------------------------------------------------- */
	/* CLASS REGEX FILTERS                                  */
	/* ---------------------------------------------------- */
	const blockedClassesFilter = [
		// Stylist utility classes.
		'stlst-selected',

		// Classes from a animate.css
		'([a-zA-Z0-9_-]+)?infinite([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?bounce([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?flash([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?pulse([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?rubberBand([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?shake([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?headShake([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?swing([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?tada([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?wobble([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?jello([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?hinge([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?fade([a-zA-Z0-9_-]+)?',

		'([a-zA-Z0-9_-]+)?slide([a-zA-Z0-9_-]+)?(In|in|Out|out)([a-zA-Z0-9_-]+)?(Up|up|Down|down|Left|left|Right|right)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?roll([a-zA-Z0-9_-]+)?(In|in|Out|out)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?fall([a-zA-Z0-9_-]+)?(In|in|Out|out|Up|up|Down|down|Left|left|Right|right)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?flip([a-zA-Z0-9_-]+)?(In|in|Out|out|Up|up|Down|down|Left|left|Right|right)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?lightSpeed([a-zA-Z0-9_-]+)?(In|in|Out|out)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?rotate([a-zA-Z0-9_-]+)?(In|in|Out|out)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?zoom([a-zA-Z0-9_-]+)?(In|in|Out|out)([a-zA-Z0-9_-]+)?',


		// Post Status classes
		'([a-zA-Z0-9_-]+)?publish([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?draft([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?pending([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?private([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?trash([a-zA-Z0-9_-]+)?',

		// Basic post formats
		'(standard|aside|audio|chat|gallery|image|link|quote|status|video)',
		// 'format-([a-zA-Z0-9_-]+)?',

		// Some functional classes
		'([a-zA-Z0-9_-]+)?viewport([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?ltr([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?padding([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?inherit([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?margin([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?relative([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?transparent([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?visibility([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?hidden([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?active-slide([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?current-slide([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?hide([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?animated([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?draggable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?resize([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?cloned([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?sortable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?status([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?-spacing-yes',
		'([a-zA-Z0-9_-s]+)?-spacing-no',
		'([a-zA-Z0-9_-]+)?clearfix([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?clear([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(clr|clfw)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?clean([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?hover([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?default_template([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?ready([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?validate([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?false([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?true([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?loading([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?loaded([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?finished([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?center([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?delay([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?enabled([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?disabled([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?ga-track([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?raw_code([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?raw_html([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?padded([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?bold([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?initialised([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?even([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?odd([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?dismissable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?underlined([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?flippable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?clickable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?gutter([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?animation([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?animate([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?transition([a-zA-Z0-9_-]+)?',

		// Functional 3rd party classes
		'([a-zA-Z0-9_-]+)?withbg([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?bg_layout([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-s]+)?rand',
		'mrg-(btm|top|left|right|tp|lft|rght)-([a-zA-Z0-9_-]+)',
		'is([_-])([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)none',

		// Wordpress Core
		'page([_-])item',
		'([a-zA-Z0-9_-]+)?object([_-])page',
		'([a-zA-Z0-9_-]+)?closed',
		'status-([a-zA-Z0-9_-]+)?',
		'thread([_-])alt',
		'([a-zA-Z0-9_-]+)?([_-])has([_-])?([a-zA-Z0-9_-]+)|([a-zA-Z0-9_-]+)?([_-])?has([_-])([a-zA-Z0-9_-]+)',
		'screen([_-])reader([_-])text',
		'tag-link([a-zA-Z0-9_-]+)?',
		'post-no-media',
		// 'category-([a-zA-Z0-9_-]+)?',

		// Browser Classes
		'([a-zA-Z0-9_-]+)?opera([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?firefox([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?safari([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?chrome([a-zA-Z0-9_-]+)?',

		// WooCommerce
		'([a-zA-Z0-9_-]+)?product_tag([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?product_cat([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?taxable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?onsale([a-zA-Z0-9_-]+)?',
		'calculated_shipping',
		'currency([a-zA-Z0-9_-]+)?',
		'woocommerce-MyAccount-navigation-link--([a-zA-Z0-9_-]+)?',

		// Etc
		'img-responsive',
		'ls-active',
		'disappear',
		'appear',
		'noSwipe',
		'wow',
		'bootstrap-touchspin-down',
		'section--no',
		'cat-item',
		'([a-zA-Z0-9_-]+)?direction-ltr',
		'([a-zA-Z0-9_-]+)?show-dropdown', // it is a hover class.
		'kc-elm',
		'kc_column',
		'selected',
		'alternate_color', // enfold
		'open-mega-a', // enfold
		'sf-menu',
		'sf-arrows',

		// Bounce after tests
		'([a-zA-Z0-9_-]+)?nojquery([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?js-comp-ver([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?wpb-js-composer([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?-shd',
		'([a-zA-Z0-9_-]+)?with([_-])([a-zA-Z0-9]+)',
		'([a-zA-Z0-9_-]+)?m-t-([0-9])+([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(serif|sans|font|webfont)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?uppercase([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?([_-])(to|from)([_-])(top|left|right|bottom)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(cursor|pointer)([a-zA-Z0-9_-]+)?',
		'(not|no)([_-])([a-zA-Z0-9_-]+)?',
		'ajax',
		'neg-marg',
		'([a-zA-Z0-9_-]+)?video-aspect-ratio-([a-zA-Z0-9_-]+)',
		'lazy',
		'lazy-img'

	];

	const preferedClassesFilter = [
		'styled-([a-zA-Z0-9_-]+)?',
		'current-menu-item',
		'active(!singleInspector)',
		'current(!singleInspector)',
		'post',
		'hentry',
		'widget',
		'wp-post-image',
		'(entry|article|post)-title',
		'(entry|article|post)-content',
		'(entry|article|post)-meta',
		'comment-author-admin',
		'([a-zA-Z0-9_-]+)?item',
		'widget-title',
		'widgettitle',
		'next',
		'prev',
		'product',
		'footer',
		'header',
		'sidebar',
		'form-control',
		'footer-top',
		'copyright',
		'menu-item',
		'kc-css-([a-zA-Z0-9_-]+)?',
		'row_inner', // cos row_inner element has a lot bad classes in themify.
		'filterall'
	];

	const unPreferedClassesFilter = [

		// Logical
		'([a-zA-Z0-9_-]+)([_-])', // End with -_
		'([_-])([a-zA-Z0-9_-]+)', // start with -_
		// '([a-zA-Z0-9_-]+)?([_-])([_-])([a-zA-Z0-9_-]+)?', // multiple -_ ex: bad--class--name

		// WordPress Dynamic Classes
		'([a-zA-Z0-9_-]+)?(tag|category|cat)([_-])([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?format([a-zA-Z0-9_-]+)?',
		'menu([_-])item([_-])type([_-])post([_-])type',
		'menu([_-])item([_-])object([_-])page',
		'menu([_-])item([_-])(object|type)([_-])custom',
		'widget_([a-zA-Z0-9_-]+)',
		'bg-([a-zA-Z0-9_-]+)',

		// Modern Columns.
		'([a-zA-Z0-9_-]+)?([_-])(l|m|s|xs)([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?pure([_-])([a-zA-Z0-9_-]+)?([_-])u([_-])[0-9]+([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?col([_-])([a-zA-Z0-9_-]+)?([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?col([_-])([a-zA-Z0-9_-]+)?([_-])offset([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?(medium|large|small)([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?(medium|large|small)([_-])([a-zA-Z0-9_-]+)?([_-])[0-9]+',

		// Bootstrap Classes
		'([a-zA-Z0-9_-]+)?(small|medium|large)([_-])(push|pull)([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?span[0-9]+',
		'([a-zA-Z0-9_-]+)?span([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?col([_-])[0-9]+([_-])[0-9]+',
		'([a-zA-Z0-9_-]+)?col([_-])[0-9]+',

		// Classic Grid Columns
		'(column|columns|col)',
		'([a-zA-Z0-9_-]+)(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)([_-]+[a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)([_-]+[a-zA-Z0-9_-]+)',

		// Structural
		'([a-zA-Z0-9_-]+)?sticky([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?fixed([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?logged([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?print([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?visible([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?trigger([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?required([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?pull([a-zA-Z0-9_-]+)(left|right)',
		'(left|right)',
		'([a-zA-Z0-9_-]+)?([_-])(yes|no)([_-])([a-zA-Z0-9_-]+)?', // _yes_
		'([a-zA-Z0-9_-]+)?(yes|no)([_-])([a-zA-Z0-9_-]+)?', // yes_
		'([a-zA-Z0-9_-]+)?([_-])(yes|no)([a-zA-Z0-9_-]+)?', // _yes,
		'([a-zA-Z0-9_-]+)?is([_-])active([a-zA-Z0-9_-]+)?', // is_active,

		// Dynamic CSS classes.
		'([a-zA-Z0-9_-]+)?background([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?width([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?height([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?position([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?parent([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?color([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?layout([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?invert([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)style([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?scroll([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?equal([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?square([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?([_-])skin([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?skin([_-])([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?toggled([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?style([0-9_-]+)',
		'([a-zA-Z0-9_-]+)?rounded([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?radius([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?type([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?dynamic([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?first',
		'([a-zA-Z0-9_-]+)?last',
		'([a-zA-Z0-9_-]+)?text([_-])justify',
		'([a-zA-Z0-9_-]+)?row([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?border([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?align([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?effect([0-9_-]+)',
		'([a-zA-Z0-9_-]+)?dimension([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?inline-inside([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?corner-pointed([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?locale([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?admin([a-zA-Z0-9_-]+)?',

		// General Theme Option Classes
		'([a-zA-Z0-9_-]+)([_-])(on|off)',
		'([a-zA-Z0-9_-]+)default([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)size([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)mobile([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)desktop([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)populated([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?hide([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?show([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?parallax([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?responsive([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?intense([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?disable([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?auto([a-zA-Z0-9_-]+)?',


		// Unyson
		'unyson-page',
		'end',

		// Pagenavi
		'larger',
		'smaller',

		// Buddypress
		'created_group',
		'mini',
		'activity_update',

		// Force Builder
		'forge-block',
		'forge-',

		// Elementor
		'elementor-section-items-middle',

		// Themify
		'themify_builder',
		'module',

		// live composer
		'dslc-post-no-thumb',

		// Woocommerce
		'downloadable',
		'purchasable',
		'instock',

		// Others
		'above',
		'open',

		// Enfold
		'template-page',
		'alpha',
		'units',
		'flex_column_div',
		'([a-zA-Z0-9_-]+)?no-sibling([a-zA-Z0-9_-]+)?',

		// bounce after tests
		'([a-zA-Z0-9_-]+)?float([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(blue|black|red|dark|white|light|green|yellow|purple|pink|orange|brown|gray)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(black|dark|white|light)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?last-child([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?first-child([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)([_-])only',
		'([a-zA-Z0-9_-]+)?(text-left|text-right)([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?(round|scale|shadow|rotate|default|minimal|animsition|nimation)([a-zA-Z0-9_-]+)?',
		'woocommerce',
		'affix-top',
		'st-menu',
		'circle',
		'vc_figure',
		'vc_general',
		'waves-effect',
		'collapsed',
		'collapse'

	];

	const noNumberClassFilter = [
		'[a-zA-Z-_]*[0-9]+[a-zA-Z0-9-_]*',
	];

	const singleDashClassFilter = [
		'[a-zA-Z0-9_]*-+[a-zA-Z0-9_]*-+[a-zA-Z0-9_-]*',
	];



	let bestClass = false
	let filteredClasses = []
	// let goodClasses = []



	// Exit rightaway if nothing to filter.
	if ( ! classes.length ) {
		return false;
	}

	// Firstly check if the we have 'styled-' class. It is the highest priority.
	bestClass = find( classes, function( elClass ) {
		if ( elClass.includes( 'styled-' ) ) {
			return true // Exit early from "find" interator.
		}
	})

	// Exit early if 'styled-' class found.
	if ( bestClass ) {
		return bestClass
	}

	// FILTER: Remove Blocked and UnPreffered classes.
	// Otherwise try to use what we have.
	if ( classes.length >= 1 ) {
		// Class filtration 1: Remove bad classes.
		const notBadClasses = removeUnwatedByFilter( classes, blockedClassesFilter )

		filteredClasses = notBadClasses

		if ( notBadClasses.length > 1 ) {
			// Class filtration 2: Remove unpreffered classes.
			const goodClasses = removeUnwatedByFilter( notBadClasses, unPreferedClassesFilter )

			filteredClasses = goodClasses
		}
	}

	// FILTER: Leave preffered classes only.
	if ( filteredClasses.length > 1 ) {
		const prefferedClasses = selectByFilter( filteredClasses, preferedClassesFilter )

		if ( prefferedClasses.length ) {
			filteredClasses = prefferedClasses
		}
	}

	// FILTER: Remove classes with numbers.
	if ( filteredClasses.length > 1 ) {
		const classesWithNoNumber = removeUnwatedByFilter( filteredClasses, noNumberClassFilter )

		if ( classesWithNoNumber.length ) {

			filteredClasses = classesWithNoNumber
		}
	}

	// FILTER: Leave classes with 4+ characters.
	if ( filteredClasses.length > 1 ) {
		var longEnoughClasses = []

		forEach( filteredClasses, function( item, key, collection ) {
			if ( item.length > 4 ) {
				longEnoughClasses.push(item)
			}
		} )

		if ( longEnoughClasses.length ) {
			filteredClasses = longEnoughClasses
		}
	}

	// FILTER: Preffer classes with single - character.
	if ( filteredClasses.length > 1 ) {
		var singleDashClasses = []

		const singleDashClasses = removeUnwatedByFilter( filteredClasses, singleDashClassFilter )

		if ( singleDashClasses.length ) {
			filteredClasses = singleDashClasses
		}
	}



	if ( filteredClasses.length > 0 ) {
		bestClass = filteredClasses[ 0 ]
	}

	return bestClass

}

function removeUnwatedByFilter( arrayToFilter, filter ) {
	var filteredArray = []

	forEach( arrayToFilter, function( item, key, collection ) {

		forEach( filter, function( singleFilter ) {
			let badStringRegex

			// Regex.
			badStringRegex = new RegExp( "(\\s|^)" + singleFilter + "(\\s|$)", "gi" )
			// Replace item with empty string if it's in a bad list.
			item = item.replace( badStringRegex, '' )

			if ( '' === item ) {

				return false // Exit early.
			}
		} )

		// Remove element from the classes array.
		if ( '' !== item ) {
			filteredArray.push( item )
		}
	} )

	return filteredArray
}

function selectByFilter( arrayToFilter, filter ) {
	var filteredArray = []

	forEach( arrayToFilter, function( item, key, collection ) {

		forEach( filter, function( singleFilter ) {
			let goodStringRegex

			// Regex.
			goodStringRegex = new RegExp( "(\\s|^)" + singleFilter + "(\\s|$)", "gi" )

			// Test item agains regex.
			if ( goodStringRegex.test( item ) ) {
				filteredArray.push( item )
				return false // Exit early.
			}
		} )
	} )

	return filteredArray
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-the-best-class.js